import { createSelector } from 'reselect';
import { RootState } from '../reducers/rootReducer';

export const getTooltipState = (state: RootState) => state.tooltip;

export const getTooltip = createSelector(getTooltipState, (tooltip) => tooltip);
